import Cookies from "js-cookie";
import { AppSettings } from '../common/AppSettings';

export const apiFetch = function (resource, init) {

    var defaultInit = init || {};
    const defaultHeaders = {
        'Authorization': 'Bearer ' + Cookies.get("__genie")
    };
    const headers = { ...defaultHeaders, ...defaultInit.headers }
    const finalInit = { ...defaultInit, headers: headers };

    return fetch(`${AppSettings.ApiHost}/${resource}`, finalInit);
}

export const isNamespaceAndKeyValid = function (namespaceAndKey) {
    return /^(.+\..+)$/.test(namespaceAndKey);
}

export const redirectToUrl = function (url) {
    window.open(url, '_blank');
}

export const fetchRulesTargetingSameMetafield = (ownerType, namespaceAndKey, ruleId) => {

    let queryString = `ownerType=${ownerType}&namespaceAndKey=${namespaceAndKey}`;

    if (ruleId != null) {
        queryString += `&ruleId=${ruleId}`
    }

    return  (`api/tagRules/rulesTargetingSameMetafield?${queryString}`, {
        method: 'GET'
    });
}

export function CheckErrorJson(response) {
    if (response.status >= 200 && response.status <= 299) {
        return response.json();
    } else {
        throw Error(response.statusText);
    }
}

export function CheckError(response) {
    if (response.status >= 200 && response.status <= 299) {
        return response;
    } else {
        throw Error(response.statusText);
    }
}

export function resourceTypeToDataPermissions(resourceType) {
    return resourceTypeToDataPermission[resourceType];
}

const resourceTypeToDataPermission = {
    "Customer" : "customers",
    "Product" : "products",
    "Order" : "orders",
}

const resourceTypes = [
    { label: 'Customer', value: 'Customer' },
    { label: 'Product', value: 'Product' },
    { label: 'Order', value: 'Order' },
];

const resourceTypeSettings =
{
    "Customer": {
        singular: "customer",
        singularStart: "Customer",
        plural: "customers",
        pluralStart: "Customers"
    },
    "Product": {
        singular: "product",
        singularStart: "Product",
        plural: "products",
        pluralStart: "Products"
    }
};

const cronOptions = [
    { label: 'Every 15 minutes', value: 'Every15Minutes' },
    { label: 'Every 30 minutes', value: 'Every30Minutes' },
    { label: 'Every hour', value: 'EveryHour' },
    { label: 'Every 6 hours', value: 'Every6Hours' },
    { label: 'Every 12 hours', value: 'Every12Hours' },
    { label: 'Every Day (At 00:00)', value: 'EveryDay' },
    { label: 'Every Week (At 00:00 on Sunday)', value: 'EveryWeek' },
    { label: 'Every Month (At 00:00 on the first day of every month)', value: 'EveryMonth' },
];

const selectFilterTypes = [
    { label: 'Product name', value: 'ProductNameFilter' },
    { label: 'Product description', value: 'ProductDescriptionFilter' },
    { label: 'Product type', value: 'ProductTypeFilter' },
    { label: 'Product vendor', value: 'ProductVendorFilter' },
    { label: 'Product price', value: 'productPrice' },
    { label: 'Product Compare at price', value: 'productCompareAtPrice' },
    { label: 'Product Price % of Compare at price', value: 'productPricePercentageOfCompareAtPrice' },
    { label: 'Product created at', value: 'productCreatedAt' },
    { label: 'Product updated at', value: 'productUpdatedAt' },
    { label: 'Product status', value: 'productStatus' },
    { label: 'Variant option', value: 'variantOption' },
    { label: 'Variant quantity', value: 'productVariantQuantity' },
    { label: 'Variant title', value: 'productVariantTitle' },
    { label: 'Inventory quantity', value: 'productInventoryQuantity' },
    { label: 'Smart collection', value: 'productSmartCollection' },
    { label: 'Product processed by Tag Operation', value: 'productProcessedByOperation' },
    { label: 'Tag', value: 'productTagsNew' },
    { label: 'Time since product creation', value: 'timeSinceProductCreation' },
];

const filterTypeToText =
{
    'ProductNameFilter': 'product name',
    'ProductDescriptionFilter': 'product description',
    'ProductTypeFilter': 'product type',
    'ProductVendorFilter': 'product vendor',
    'variantOption': 'variant',
    'productUpdatedAt': 'product updated at',
    'productCreatedAt': 'product created at',
    'productTagsNew': 'tag',
    'ProductStatusFilter': 'product status',
    'productSmartCollection': 'smart collection',
    'productProcessedByOperation': 'product processed by operation',
    'timeSinceProductCreation': 'time since product was created',
    // 'ProductVariantQuantityFilter': 'variant quantity'
};

const operatorsToText =
{
    'EqualTo': 'is',
    'NotEqualTo': 'is not',
    'GreaterThan': 'is greater than',
    'StartsWith': 'starts with text',
    'DoesNotStartWith': 'does not start with text',
    'EndsWith': 'ends with text',
    'DoesNotEndWith': 'does not end with text',
    'Contains': 'contains text',
    'DoesNotContain': 'does not contain text',
    'Exists': 'exists',
    'DoesNotExist': 'does not exist',
    'IsAvailable': 'is in stock',
    'IsNotAvailable': 'is not in stock',
    'HasTag': 'contain tag',
    'DoesNotHaveTag': 'does not contain tag'
};

const variantConditionToText =
{
    'AllVariants': 'all variants',
    'AnyVariant': 'any variant',
    'NoVariants': 'no variant',
};

const priceConditionToText =
{
    'EqualTo': 'is equal to',
    'NotEqualTo': 'is not equal to',
    'GreaterThan': 'is greater than',
    'GreaterThanOrEqual': 'is greater than or equal to',
    'LessThan': 'is less than',
    'LessThanOrEqual': 'is less than or equal to',
};

const compareAtPriceConditionToText =
{
    'IsSet': 'is set',
    'IsNotSet': 'is NOT set',
    'EqualTo': 'is equal to',
    'NotEqualTo': 'is NOT equal to',
    'GreaterThan': 'is greater than',
    'GreaterThanOrEqual': 'is greater than or equal to',
    'LessThan': 'is less than',
    'LessThanOrEqual': 'is less than or equal to',
};

const quantityConditionToText =
{
    'EqualTo': 'is equal to',
    'GreaterThan': 'is greater than',
    'GreaterThanOrEqual': 'is greater than or equal to',
    'LessThan': 'is less than',
    'LessThanOrEqual': 'is less than or equal to',
};

const dateConditionToText =
{
    'EqualTo': 'is',
    'NotEqualTo': 'is not',
    'GreaterThan': 'is after',
    'GreaterThanOrEqual': 'is or after',
    'LessThan': 'is before',
    'LessThanOrEqual': 'is or before',
};

const smartCollectionConditionToText =
{
    'BelongsTo': 'belong to',
    'DoesNotBelongTo': 'do NOT belong to',
};

const productProcessedByOperationFilterConditionToText =
{
    'Processed': 'were processed by',
    'NotProcessed': 'were NOT processed by',
};

const unitOfTimeToText =
{
    'Minutes': 'minutes',
    'Hours': 'hours',
    'Days': 'days',
};

const timeSinceProductCreationConditionToText =
{
    'AtLeast': 'at least',
    'AtMost': 'at most',
    'Exactly': 'exactly',
};

function getFilterText(filter, smartCollections) {

    if (filter.filterType === "productPrice") {
        return `price of ${variantConditionToText[filter.variantCondition]} ${priceConditionToText[filter.priceCondition]} ${filter.price}`;
    }

    if (filter.filterType === "productCompareAtPrice") {

        const conditionRequiresPrice = !(filter.priceCondition === "IsSet" || filter.priceCondition === "IsNotSet");

        if (conditionRequiresPrice) {
            return `Compare at price of ${variantConditionToText[filter.variantCondition]} ${compareAtPriceConditionToText[filter.priceCondition]} ${filter.price}`;
        }
        else {
            return `Compare at price of ${variantConditionToText[filter.variantCondition]} ${compareAtPriceConditionToText[filter.priceCondition]}`;
        }
    }

    if (filter.filterType === "productPricePercentageOfCompareAtPrice") {

        return `Price percentage of Compare at price is ${priceConditionToText[filter.percentageCondition]} ${filter.percentage} for ${variantConditionToText[filter.variantCondition]}`;
    }

    if (filter.filterType === "productInventoryQuantity") {
        return `inventory quantity of ${variantConditionToText[filter.variantCondition]} ${quantityConditionToText[filter.quantityCondition]} ${filter.quantity}`;
    }

    if (filter.filterType === "productVariantQuantity") {
        return `variant quantity of ${filter.variantTitle} ${quantityConditionToText[filter.quantityCondition]} ${filter.quantity}`;
    }

    if (filter.filterType === "productVariantTitle") {
        return `variant title ${operatorsToText[filter.operator]} ${filter.value}`;
    }

    if (filter.filterType === "productCreatedAt") {
        return `product created at ${dateConditionToText[filter.operator]} ${filter.value}`;
    }

    if (filter.filterType === "productUpdatedAt") {
        return `product updated at ${dateConditionToText[filter.operator]} ${filter.value}`;
    }

    if (filter.filterType === "productStatus") {
        return `product status ${operatorsToText[filter.condition]} ${filter.status}`;
    }

    if (filter.filterType === "productSmartCollection") {
        let collection = smartCollections.find(_ => _.id === filter.productCollectionId);
        let collectionText = filter.productCollectionId;

        if (collection != null && collection !== undefined) {
            collectionText = collection.title;
        }

        return `products ${smartCollectionConditionToText[filter.condition]} ${collectionText}`;
    }

    if (filter.filterType === "productProcessedByOperation") {
        return `products ${productProcessedByOperationFilterConditionToText[filter.condition]} tag operation with id: ${filter.tagOperationId}`;
    }

    if (filter.filterType === "timeSinceProductCreation") {
        return `time elapsed since product was created is ${timeSinceProductCreationConditionToText[filter.condition]} ${filter.timeOffsetLength} ${unitOfTimeToText[filter.timeOffsetUnit]}`;
    }

    return `${filterTypeToText[filter.filterType]} ${operatorsToText[filter.operator]} ${filter.value}`;
}

export const getOperationText = function (operation, smartCollections) {

    let operator = operation.productFiltersLogicalOperator === "And" ? "AND" : "OR";
    let filterText = " from all products";

    if (operation.productFilters.length > 0) {
        let conditionTexts = operation.productFilters.map((item) => getFilterText(item, smartCollections));
        filterText = " where " + conditionTexts.join(` ${operator} `);
    }

    let actionsTexts = operation.actions.map((item) => {

        if (item.type === "add") {
            return `Tag ${item.tagName} will be added`
        }

        if (item.type === "remove") {
            let actionCondition = `${operatorsToText[item.filter.operator]} ${item.filter.value}`;

            return `Tags ${actionCondition} will be removed`
        }

        if (item.type === "rename") {
            let actionCondition = `${operatorsToText[item.filter.operator]} ${item.filter.value}`;

            return `Tags ${actionCondition} will be ranamed to ${item.tagName}`
        }

        if (item.type === "conditionalAdd") {
            let actionCondition = `${operatorsToText[item.filter.operator]} ${item.filter.value}`;

            return `Tag ${item.tagName} will be added where ${actionCondition}`
        }

        if (item.type === "changePrefix") {

            if (item.keepOriginalTags) {
                return `Add new tags with prefix ${item.newPrefix} based on original prefix ${item.originalPrefix}`;
            }
            else {
                return `Changing tag prefix ${item.originalPrefix} to ${item.newPrefix}`;
            }
        }

        return "";
    });

    return actionsTexts.join(` AND `) + `${filterText}`;

};

export const mapToFilter = function (filter) {

    if (filter.filterType === "ProductVendorFilter") {

        return {
            ...filter,
            filterType: "property",
            field: "Vendor"
        };
    }

    if (filter.filterType === "ProductDescriptionFilter") {

        return {
            ...filter,
            filterType: "property",
            field: "ProductDescription"
        };
    }

    if (filter.filterType === "ProductTypeFilter") {

        return {
            ...filter,
            filterType: "property",
            field: "ProductType"
        };
    }

    if (filter.filterType === "ProductNameFilter") {

        return {
            ...filter,
            filterType: "property",
            field: "ProductName"
        };
    }

    return filter;
}

export const mapFromFilter = function (filter) {

    if (filter.filterType !== "property") {
        return filter;
    }

    var filterType = "ProductNameFilter";

    if (filter.field === "Vendor") {
        filterType = "ProductVendorFilter"
    }

    if (filter.field === "ProductDescription") {
        filterType = "ProductDescriptionFilter"
    }

    if (filter.field === "ProductType") {
        filterType = "ProductTypeFilter"
    }

    return {
        ...filter,
        filterType: filterType
    };
}

export const SelectFilterTypes = selectFilterTypes
export const CronOptions = cronOptions
export const ResourceTypes = resourceTypes
export const ResourceTypeSettings = resourceTypeSettings
